import { useNavigation } from '@remix-run/react'
import { useEffect, useRef } from 'react'
import type { LoadingBarRef } from 'react-top-loading-bar'
import LoadingBar from 'react-top-loading-bar'

export function NavigationLoadingBar() {
    const navigation = useNavigation()
    const ref = useRef<LoadingBarRef>(null)

    useEffect(() => {
        if (navigation.state === 'loading' || navigation.state === 'submitting') {
            ref.current?.continuousStart(0, 100)
        }

        if (navigation.state === 'idle') {
            ref.current?.complete()
        }
    }, [navigation.state])

    return <LoadingBar ref={ref} color='#BFDBFE' shadow={false} height={2} transitionTime={100} waitingTime={300} />
}